import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import {UserManagementService} from '../user-management.service';

@Component({
  selector: 'app-delete-user',
  templateUrl: './delete-user.component.html',
  providers: [UserManagementService],
  styleUrls: ['./delete-user.component.less']
})
export class DeleteUserComponent implements OnInit {
  @Input() deleteUserConfirmation: boolean;
  @Input() userId;
  @Input() fromGroupDatabase: boolean;
  @Output() deleteUserConfirmationChange = new EventEmitter<boolean>();
  @Output() deleteUserChange = new EventEmitter();

  buttonsEnabled = true;
  constructor(private userService: UserManagementService) { }

  ngOnInit() {
    console.log(this.userId);
  }

  closeX() {
    if (this.buttonsEnabled) {
      this.deleteUserConfirmationChange.emit(false);
    }
  }
  close() {
      this.deleteUserConfirmationChange.emit(false);
  }

  deleteUser() {
    const component = this;
    this.buttonsEnabled = false;
    if (this.fromGroupDatabase) {
      this.close();
      this.deleteUserChange.emit('groupProfileDelete');
    } else {
      this.userService.deleteUser(this.userId)
        .subscribe(
          (response) => {
            component.deleteUserChange.emit();
            component.close();
          },
          (error) => {
            component.close();
            this.buttonsEnabled = true;

            console.log(error);
          }
        );
    }

  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/user-management/user-details/delete-user.component.ts